import * as yup from 'yup'

export class VehicleSendBackToCanadaDto {
  sentBackToCanadaDate?: string = undefined
  recordNumber?: string = undefined
}

export const vehicleSendBackToCanadaValidationSchema = yup.object<VehicleSendBackToCanadaDto>({
  sentBackToCanadaDate: yup
    .date()
    .typeError('Sent Back To Canada Date must be a valid date.')
    .required('Sent Back To Canada Date is required.'),
  recordNumber: yup
    .string()
    .max(255, 'Record # cannot be more than 255 characters.')
    .nullable()
    .required('Record # is required.')
})
